export const typePrefix = {
  MAP_OVERVIEW : 'MAP_OVERVIEW',
  MAP_DETAILS : 'MAP_DETAILS',
  MAP_STATUS : 'MAP_STATUS',
}
